<template>
  <div class="guides">
    <h1>Guides</h1>
    <p class="muted">
      HTML copies of the facilitator and student guides. Markdown sources stay in the repo under
      <code>guides/</code>. Only admins see these pages in the app.
    </p>
    <div class="cards">
      <router-link class="card" to="/admin/guides/admin">
        <span class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5V5.5Z"
              stroke="currentColor"
              stroke-width="1.75"
            />
            <path d="M8 7h8M8 11h8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
          </svg>
        </span>
        <h2>Admin guide</h2>
        <p>Colleges, approvals, polls, and what students cannot do.</p>
      </router-link>
      <router-link class="card" to="/admin/guides/student">
        <span class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5V5.5Z"
              stroke="currentColor"
              stroke-width="1.75"
            />
            <path d="M8 7h8M8 11h8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
          </svg>
        </span>
        <h2>Student guide</h2>
        <p>Sign-in, college pick, express interest, and when they can enter.</p>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
h1 {
  margin: 0 0 0.5rem;
}

.cards {
  display: grid;
  gap: 1rem;
  margin-top: 1.5rem;
}

@media (min-width: 720px) {
  .cards {
    grid-template-columns: 1fr 1fr;
  }
}

.card {
  display: block;
  text-decoration: none;
  color: inherit;
  background: var(--cream);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 1.25rem 1.35rem;
  box-shadow: var(--shadow-soft);
}

.card:hover {
  border-color: var(--teal);
}

.icon {
  display: inline-flex;
  color: var(--teal);
}

.icon svg {
  width: 1.6rem;
  height: 1.6rem;
}

h2 {
  margin: 0.65rem 0 0.35rem;
  font-size: 1.2rem;
}

.card p {
  margin: 0;
  color: var(--muted);
}
</style>
